import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline'
import WorkOutlineIcon from '@mui/icons-material/WorkOutline'
import { Box, Button, Radio, Typography } from '@mui/material'
import Modal from '@mui/material/Modal'
import { displayPriceFunction } from 'components/Common/DisplayValues/DisplayPrice'
import ModalDetails from 'Pages/Client/BookingStatusPage/Common/AmendModalDetails'
import {
  AlternativeOptionProps,
  QuotesProp,
} from 'Pages/Client/BookingStatusPage/ReallocateModal/QuotesTitle'
import React from 'react'
import IconCar from '../../../assets/icon/icon-car.svg'
import IconChaffuer from '../../../assets/icon/icon-chaffeur.svg'
import IconGreenBadge from '../../../assets/icon/icon-green-badge.svg'
import IconInfo from '../../../assets/icon/icon-info.svg'
import IconTime from '../../../assets/icon/icon-time.svg'

type ModalDataQuote = {
  title: string
  example: string
  cardist: string
  image: string
  seats: number
  luggage: number
  quotes?: QuotesProp
}

interface ModalProp {
  data: ModalDataQuote
  openModal: boolean
  isImmediateJourney: boolean
  displayVATPrice: boolean
  selectedVehicles: any
  setSelectedVehicles: any
  isFlexible: (QuotesProp & AlternativeOptionProps) | null
  numOfVehicle: number
  currentBooking: any
  isOneWay: boolean
  isAsDirected: boolean
  quoteReference: string
  setEditState: any
  setNumOfVehicle: React.Dispatch<React.SetStateAction<number>>
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>
  handleBookCar: any
}

const untrackedMessage = `The provider you are booking does not offer real time tracking, meaning its location won't be visible on the map. You'll still receive live updates to keep you informed throughout your journey.`

const VehicleDetailsModal = ({
  data,
  openModal,
  isOneWay,
  isAsDirected,
  isImmediateJourney,
  displayVATPrice,
  isFlexible,
  setSelectedVehicles,
  selectedVehicles,
  currentBooking,
  quoteReference,
  handleBookCar,
  setEditState,
  setOpenModal,
}: ModalProp) => {
  const [isFlexibleOption, setFlexibleOption] = React.useState(false)
  console.log('setSelectedVehicle', setSelectedVehicles)
  const btnPrice = () => {
    if (!data) return
    const regularPrice = displayPriceFunction(
      selectedVehicles?.estimatedTotal,
      displayVATPrice,
    )

    return {
      price: regularPrice?.exactPrice,
      currency: regularPrice?.currencySymbolValue,
    }
  }

  return (
    <Modal
      disableScrollLock
      open={openModal}
      onClose={() => {
        setOpenModal(false)
        setSelectedVehicles({})
      }}
    >
      <Box
        component="div"
        sx={{
          position: 'absolute' as 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '40%',
          minWidth: '1172px',
          bgcolor: 'background.paper',
          boxShadow: 24,
          display: 'flex',
          maxHeight: '780px',
          overflow: 'auto',
          borderRadius: '5px',
          '@media (max-height: 784px)': {
            height: '90vh',
          },
        }}
        className="custom-scrollbar"
      >
        <Box
          component="div"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            maxWidth: '548px',
            padding: '24px',
            height: '100%',
          }}
        >
          <Box
            component="div"
            sx={{
              width: '500px',
              height: '400px',
              backgroundColor: '#F7F7F7',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginBottom: '24px',
              position: 'relative',
              borderRadius: '5.13px',
            }}
          >
            {data?.image && (
              <Box
                component="img"
                src={data?.image}
                style={{
                  height: 'auto',
                  width: '100%',
                }}
              />
            )}
            <Box
              component="div"
              sx={{
                position: 'absolute',
                top: '4px',
                left: '4px',
                display: 'flex',
              }}
            >
              {data.title?.toLowerCase()?.includes('chauffer') && (
                <Box
                  component="img"
                  src={IconChaffuer}
                  sx={{
                    width: '96px',
                    height: '96px',
                  }}
                />
              )}
              {(data.title?.toLowerCase()?.includes('zero') ||
                data.title?.toLowerCase()?.includes('hybrid')) && (
                <Box
                  component="img"
                  src={IconGreenBadge}
                  sx={{
                    width: '96px',
                    height: '96px',
                  }}
                />
              )}
            </Box>
          </Box>
          {!data.quotes?.isTrackable && (
            <Box
              component="div"
              sx={{
                display: 'flex',
                marginTop: '24px',
              }}
            >
              <Typography
                component="p"
                sx={() => ({
                  color: '#414042',
                  fontWeight: '400',
                  fontSize: '14px',
                  lineHeight: '21px',
                })}
              >
                This car is
                <Typography
                  component="span"
                  sx={() => ({
                    color: '#414042',
                    fontWeight: '700',
                    fontSize: '14px',
                    lineHeight: '21px',
                    marginLeft: '4px',
                  })}
                >
                  untracked.
                </Typography>
              </Typography>
              <Box
                component="div"
                className="tooltip-wrapper"
                sx={{
                  position: 'relative',
                  cursor: 'pointer',
                }}
              >
                <Box
                  component="img"
                  src={IconInfo}
                  alt="info"
                  sx={{
                    marginLeft: '4px',
                  }}
                />
                <Box
                  component="div"
                  className="tooltip left-untracked"
                  sx={{
                    width: '281px',
                    zIndex: 20,
                    left: '-128px',
                    top: 'unset',
                    bottom: '26px',
                  }}
                >
                  <Typography
                    component="span"
                    sx={() => ({
                      color: '#fff',
                      fontWeight: '400',
                      fontSize: '12px',
                      lineHeight: '16px',
                    })}
                  >
                    {untrackedMessage}
                  </Typography>
                </Box>
              </Box>
            </Box>
          )}
          {data?.quotes?.isPreferredSupplier ? (
            <Box
              component="div"
              sx={{
                display: 'flex',
                flexDirection: 'column',
                marginTop: '32px',
                visibility: data?.quotes?.isPreferredSupplier
                  ? 'visible'
                  : 'hidden',
              }}
            >
              <Typography
                component="p"
                sx={() => ({
                  color: '#414042',
                  fontWeight: '300',
                  fontSize: '16px',
                  lineHeight: '21px',
                })}
              >
                Your ride will be coming from:
              </Typography>
              {data.quotes?.supplierLogo ? (
                <Box
                  component="img"
                  src={data.quotes?.supplierLogo}
                  alt="chevron"
                  sx={{
                    width: '140px',
                    height: 'auto',
                    marginTop: '12px',
                  }}
                />
              ) : (
                <Typography
                  component="p"
                  sx={(theme) => ({
                    color: theme.palette.brand.dark,
                    fontWeight: '700',
                    fontSize: '20px',
                    lineHeight: '20px',
                    textTransform: 'uppercase',
                    marginTop: '12px',
                  })}
                >
                  {data.quotes?.supplierName}
                </Typography>
              )}
            </Box>
          ) : (
            <></>
          )}
        </Box>
        <Box
          component="div"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '624px',
            padding: '32px 16px 32px 24px',
            justifyContent: 'space-between',
            position: 'relative',
            maxHeight: '735px',
            overflow: 'auto',
          }}
          className="custom-scrollbar"
        >
          <Box
            component="div"
            sx={{
              display: 'flex',
              flexDirection: 'column',
              marginBottom: '75px',
            }}
          >
            <Box
              component="div"
              sx={() => ({
                display: 'flex',
                justifyContent: 'space-between',
              })}
            >
              <Typography
                component="p"
                sx={() => ({
                  color: '#0A2435',
                  fontWeight: '600',
                  fontSize: '19px',
                  lineHeight: '21px',
                })}
              >
                {data?.title}
              </Typography>
              <Typography
                component="p"
                sx={() => ({
                  color: '#414042',
                  fontWeight: '600',
                  fontSize: '19px',
                  lineHeight: '21px',
                })}
              >
                {`${btnPrice()?.currency} ${btnPrice()?.price}`}
              </Typography>
            </Box>
            <Typography
              component="p"
              sx={() => ({
                color: '#414042',
                fontWeight: '300',
                fontSize: '17px',
                lineHeight: '21px',
                marginTop: '8px',
              })}
            >
              {data?.cardist}
            </Typography>
            <Box
              component="div"
              sx={{
                display: 'flex',
                flexDirection: 'row',
                gap: '16px',
                marginTop: '16px',
              }}
            >
              {data.cardist && (
                <Box
                  component="div"
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    fontWeight: 'normal',
                    alignItems: 'center',
                    gap: '5px',
                    alignSelf: 'flex-end',
                  }}
                >
                  <Box
                    component="img"
                    src={IconCar}
                    alt="info"
                    sx={{
                      marginLeft: '4px',
                      width: '24px',
                      height: '24px',
                    }}
                  />
                  <Typography
                    component="span"
                    sx={() => ({
                      color: '#414042',
                      fontWeight: '400',
                      fontSize: '16px',
                      lineHeight: '19.36px',
                    })}
                  >
                    {data?.example}
                  </Typography>
                </Box>
              )}
              {data.seats && (
                <Box
                  component="div"
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    fontWeight: 'normal',
                    alignItems: 'center',
                    gap: '5px',
                    alignSelf: 'flex-end',
                  }}
                >
                  <PeopleOutlineIcon />
                  <span>{data.seats}</span>
                </Box>
              )}
              {data.luggage && (
                <Box
                  component="div"
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    fontWeight: 'normal',
                    alignItems: 'center',
                    gap: '5px',
                    alignSelf: 'flex-end',
                  }}
                >
                  <WorkOutlineIcon />
                  <span>{data.luggage}</span>
                </Box>
              )}
            </Box>
            {isFlexible?.vehicleTypeName && (
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <Box
                  component="div"
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    marginTop: '24px',
                    justifyContent: 'space-between',
                    marginLeft: '-12px',
                  }}
                >
                  <Box
                    component="div"
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '8px',
                      width: '100%',
                    }}
                  >
                    <Box
                      component="div"
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                      }}
                    >
                      <Box
                        component="div"
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                        }}
                      >
                        <Radio
                          checked={!isFlexibleOption}
                          onChange={() => setFlexibleOption(false)}
                          value="a"
                          name="radio-buttons"
                        />
                        <Typography
                          component="p"
                          onClick={() => setFlexibleOption(false)}
                          sx={() => ({
                            color: '#414042',
                            fontWeight: '300',
                            fontSize: '16px',
                            lineHeight: '21px',
                            cursor: 'pointer',
                          })}
                        >
                          Non-refundable with less than 12-hour notice
                        </Typography>
                      </Box>
                      <Typography
                        component="p"
                        sx={() => ({
                          color: '#414042',
                          fontWeight: '400',
                          fontSize: '16px',
                          lineHeight: '24px',
                        })}
                      >
                        {`+ ${btnPrice()?.currency ?? ''}0.00`}
                      </Typography>
                    </Box>
                    <Box
                      component="div"
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                      }}
                    >
                      <Box
                        component="div"
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          width: 'calc(100% - 100px)',
                        }}
                      >
                        <Radio
                          checked={isFlexibleOption}
                          onChange={() => setFlexibleOption(true)}
                          value="b"
                          name="radio-buttons"
                        />
                        <Typography
                          component="p"
                          onClick={() => setFlexibleOption(true)}
                          sx={() => ({
                            color: '#414042',
                            fontWeight: '300',
                            fontSize: '16px',
                            lineHeight: '21px',
                            cursor: 'pointer',
                          })}
                        >
                          {`Fully refundable until
                            ${
                              isFlexible?.vehicleDetails
                                ?.fullyRefundableUntil || '-'
                            }
                          `}
                        </Typography>
                      </Box>
                      <Typography
                        component="p"
                        sx={() => ({
                          color: '#414042',
                          fontWeight: '400',
                          fontSize: '16px',
                          lineHeight: '24px',
                        })}
                      >
                        {`+ ${
                          displayPriceFunction(
                            data.quotes?.price,
                            displayVATPrice,
                          )?.currencySymbolValue
                        }${Math.abs(
                          (Number(
                            displayPriceFunction(
                              data.quotes?.price,
                              displayVATPrice,
                            )?.exactPrice || 0,
                          ) || 0) -
                            (Number(
                              displayPriceFunction(
                                isFlexible?.price,
                                displayVATPrice,
                              )?.exactPrice || 0,
                            ) || 0),
                        ).toFixed(2)}`}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
            )}
            <Box
              component="div"
              sx={{
                display: 'flex',
                flexDirection: 'column',
                marginTop: '40px',
                gap: '8px',
              }}
            >
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: '8px',
                }}
              >
                <Typography
                  component="p"
                  sx={() => ({
                    color: '#414042',
                    fontWeight: '600',
                    fontSize: '17px',
                    lineHeight: '21px',
                  })}
                >
                  Cancellation Policy
                </Typography>
                <Box
                  component="div"
                  className="tooltip-wrapper"
                  sx={{
                    position: 'relative',
                    cursor: 'pointer',
                  }}
                >
                  <Box component="img" src={IconInfo} alt="info" />
                  <Box
                    component="div"
                    className="tooltip untracked"
                    sx={{
                      width: '281px',
                      zIndex: 20,
                      left: '-133px',
                      top: '27px',
                    }}
                  >
                    <Typography
                      component="span"
                      sx={() => ({
                        color: '#fff',
                        fontWeight: '400',
                        fontSize: '12px',
                        lineHeight: '16px',
                      })}
                    >
                      {isFlexibleOption
                        ? isFlexible?.vehicleDetails?.cancellationPolicy
                        : data?.quotes?.vehicleDetails?.cancellationPolicy ||
                          '-'}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
            <ModalDetails
              price={Number(btnPrice()?.price)}
              currency={btnPrice()?.currency || ''}
              isFlexibleOption={isFlexibleOption}
              displayVat={displayVATPrice}
              currentBooking={currentBooking}
              additionalOptions={
                isFlexibleOption
                  ? Math.abs(
                      (Number(
                        displayPriceFunction(isFlexible?.price, displayVATPrice)
                          ?.exactPrice || 0,
                      ) || 0) -
                        (Number(
                          displayPriceFunction(
                            data.quotes?.price,
                            displayVATPrice,
                          )?.exactPrice || 0,
                        ) || 0),
                    )
                  : isFlexible?.vehicleTypeName
                  ? 'displayOnly'
                  : 0
              }
            />
          </Box>
          <Box
            component="div"
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
              position: 'fixed',
              width: 'calc(100% - 587px)',
              bottom: '0',
              paddingBottom: '32px',
              background: '#fff',
            }}
          >
            <Box
              component="div"
              sx={{
                display: 'flex',
                borderRadius: '4px',
                padding: '12px',
                gap: '6px',
                backgroundColor: '#EBF4FF',
                height: 'max-content',
                alignItems: 'center',
                visibility: isImmediateJourney ? 'visible' : 'hidden',
              }}
            >
              <Box
                component="img"
                src={IconTime}
                alt="info"
                sx={{
                  marginLeft: '4px',
                  width: '24px',
                  height: '24px',
                }}
              />
              <Typography
                component="p"
                sx={() => ({
                  color: '#002EA5',
                  fontWeight: '400',
                  fontSize: '20px',
                  lineHeight: '24px',
                  height: 'max-content',
                })}
              >
                {`ETA ${
                  data.quotes?.eta == 99
                    ? 'unavailable'
                    : `${data.quotes?.eta} mins`
                }`}
              </Typography>
            </Box>

            <Button
              sx={{ fontSize: '16px', padding: '16px' }}
              onClick={() => {
                handleBookCar('amendedQuote', {
                  quoteReference: quoteReference,
                  vehicles: [
                    {
                      supplierQuoteReference:
                        selectedVehicles.supplierQuoteReference,
                      quantity: 1,
                    },
                  ],
                })

                setSelectedVehicles(selectedVehicles)
                setEditState('vehicle', false)
                setEditState('journey', false)
                setOpenModal(false)
              }}
            >
              {isOneWay || isAsDirected ? `SELECT` : 'Add to Booking'}
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  )
}

export default VehicleDetailsModal
